import SavingThrowsPane from "./SavingThrowsPane";

export default SavingThrowsPane;
export { SavingThrowsPane };
